import React from 'react'
import * as FlexmonsterReact from 'react-flexmonster'
import {withStyles} from '@material-ui/core/styles'
import { account } from '../../services/Authentication'
import { Link, withRouter } from "react-router-dom"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Create from '@material-ui/icons/Create'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import RefreshIcon from '@material-ui/icons/Refresh'
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled'
import { DataUtilsService } from '../../services/DataUtilsService'

//chart
import ChartBasic from './ChartBasic'

//Service
import DatasetDynamicService from '../../services/DatasetDynamicService'

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 20,
  },
  paper: {
    padding: theme.spacing(2),      
    color: theme.palette.text.secondary,    
  },    
  formControl: {
    margin: theme.spacing(2),      
  },
  button: {
    margin: theme.spacing(1),
  },
  textArea: {
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    color:'rgba(0,0,0,.6)',
    fontWeight:9,
    "&:hover": {
      color:'rgba(0,0,0,.8)',
    },
  },  
  headerLink:{
    display:'flex',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
});

class CardPanel extends React.Component {

  constructor(props){
    super(props);         
    this.refFlexmonster = React.createRef()

    this.state = {
      report: {},      
    }
  }

  componentDidMount(prevProps) {        
    this.executeQuery()
  }

  componentDidUpdate(prevProps) {    
    if(this.props.dataset.id !== prevProps.dataset.id) {
      this.executeQuery()
    }
  }

  getBearerToken = () => {
    return this.props.isEmbed === true ? this.props.bearerToken : null;
  }

  cleanCache = (id) => {
    const response = DatasetDynamicService.cleanCache(id, this.getBearerToken());
    response.then(()=> this.executeQuery()).catch((error)=> console.error(error))
  }

  executeQuery = () => {    
          
    if(!this.props.dataset.id) return
    
    if(this.props.dataset.chartType === 'funnel'){
      this.setState({report: {}})
      return
    }

    const response = DatasetDynamicService.executeQuery(
      {            
        query: "",
        connectorId: "",
        datasetId: this.props.dataset.id
      }, 
      this.getBearerToken()
    );            
    response
      .then( (resp) => {               

        const contentReport = DataUtilsService.getObjectByAnything(resp.data);

        if(this.props.dataset.out === "flexmonster"){
          let flexReport = JSON.parse(this.props.dataset.report);
          flexReport.dataSource.data = contentReport                                           
          this.refFlexmonster.current.flexmonster.setReport(flexReport)                
        } else if(this.props.dataset.out === "chartsHighcharts") {
          
          let report = JSON.parse(this.props.dataset.report)

          //**Reestrutura o a categoria do gráfico, ou seja monta uma nova ordenação da legenda  */
          try{
            let category = JSON.parse(this.props.dataset.managerOptions).find( m => {
              return m.identify === 'category'
            } );
            //atributo para obter a nova estrutura da categoria
            let nameCategory = category.data[0].name;
            let newxAxisCategories = contentReport.map( c => c[nameCategory]);
            report.xAxis.categories = newxAxisCategories;

          }catch (error){
            console.error(error);
          }

          report.series.map(serie=>{
            return serie.data = contentReport.map(o=>o[serie.name])
          })

          this.setState({report: report})
        }
        
      })
      .catch(err => {
        console.error(err)
      })                      
  }

  render(){

    const { classes, dataset } = this.props;

    return(
   
      <Grid 
          item xs={12} 
          md={dataset.spaceWidth?dataset.spaceWidth:4} 
          key={dataset.id}
      >     
        <Paper className={classes.paper} >   
            <Grid item xs={12} className={classes.headerLink} >
              <div>
                {!this.props.isEmbed ? 
                  (
                    <Link className={classes.link} to={"/pivot/module/"+dataset.id} ><Typography>{dataset.description}</Typography></Link>                  
                  ) : (
                    <Typography>{dataset.description}</Typography>
                  ) 
                }
              </div>
              <div>                  
                  {!this.props.isEmbed && account().empresa === 12?(                         
                    <Tooltip title="Editar painel" >  
                      <Link className={classes.link} to={"/dataset/add/"+dataset.id} >                      
                        <IconButton  size="small">
                          <Create fontSize="inherit" />
                        </IconButton>
                      </Link>
                    </Tooltip>
                    ):''} 
                  
                <Tooltip title="Excluir cache e recarregar" >   
                  <IconButton  size="small" onClick={() => this.cleanCache(dataset.id)} >
                    <SyncDisabledIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Atualizar informações" >   
                  <IconButton  size="small" onClick={() => this.executeQuery()} >
                    <RefreshIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                
              </div>
            </Grid>     
           
           {this.props.dataset.out === "flexmonster"?(<FlexmonsterReact.Pivot   
              ref={this.refFlexmonster}                                                        
              toolbar={true}
              height={dataset.spaceHeight?dataset.spaceHeight:400}              
              licenseKey={process.env.REACT_APP_FLEXMONSTER_KEY}            
            />)
           :this.props.dataset.out === "chartsHighcharts"?(<ChartBasic dataset={this.props.dataset} report={this.state.report} />) 
           :("")}
            
                       
        </Paper>    
      </Grid>
    
  ) 

}

}

export default withStyles(useStyles)(withRouter(CardPanel))
